import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import useFetch from "hooks/useFetch";
import { sendMessage } from "../../utils/webview";
import { useRecoilValue } from "recoil";
import { permanentDataAtom } from "../../recoil/permanentDataAtom";
import DefaultPage from "../container/DefaultPage";
import { CircularProgress, Stack } from "@mui/joy";

// 파트너 전용 토스 실패 페이지. 실패 기록 후 파트너 결제 페이지로 복귀(재시도).
export default function PartnerTossPaymentsFail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get("orderId");
  const code = searchParams.get("code");
  const message = searchParams.get("message");
  const { slug } = useParams();

  const permanentDataState = useRecoilValue(permanentDataAtom);
  const isInappWebview = permanentDataState?.isWebview;

  const [paymentFailData, paymentFail] = useFetch({
    url: `/payment/toss-payments/fail`,
    requestBody: JSON.stringify({
      orderId: orderId,
      code: code,
      message: message,
    }),
  });

  useEffect(() => {
    if (orderId) {
      paymentFail();
    }
  }, [orderId]);

  useEffect(() => {
    if (paymentFailData) {
      if (isInappWebview) {
        sendMessage(
          JSON.stringify({
            event: "toss_payments",
            params: {
              status: code === "PAY_PROCESS_CANCELED" ? "cancel" : "fail",
            },
          })
        );
      } else {
        navigate(slug ? `/partner/${slug}` : "/", { replace: true });
      }
    }
  }, [paymentFailData]);

  return (
    <DefaultPage
      content={
        <Stack alignItems={"center"}>
          <CircularProgress color="neutral" />
        </Stack>
      }
    />
  );
}
